import RegionTools from 'utils/regions/regionTools'
import geoJSON from 'utils/geoJSON/geoJSON'

const formatMapSeries = ({ data, regionsData, selectedRegionId }) => {
  let chartData = []
  let usefulData = data.data.map(item => ({
    name: RegionTools.getRegionNameFromId({
      id: data.query.geo[item.geoset],
      regionsData
    }),
    code: RegionTools.getRegionCodeFromId({
      id: data.query.geo[item.geoset],
      regionsData
    }),
    id: data.query.geo[item.geoset],
    value: item.value
  }))

  usefulData.forEach(item => {
    if (Number(item.id) === Number(selectedRegionId)) {
      chartData.push({
        code: item.code,
        regionName: item.name,
        value: item.value
      })
    } else {
      chartData.push({
        code: item.code,
        regionName: item.name,
        value: item.value
      })
    }
  })

  let series = [
    {
      type: 'map',
      index: 1,
      mapData: geoJSON.regionLevel,
      data: chartData,
      joinBy: ['NUTS_ID', 'code'],
      states: {
        hover: {
          color: '#0fa4c4'
        }
      }
    },
    {
      type: 'mapline',
      index: 2,
      mapData: geoJSON.countryLevel,
      nullColor: '#333',
      showInLegend: false,
      includeInCSVExport: false,
      name: 'borders',
      lineWidth: 0.75,
      color: '#CCCCCC',
      dataLabels: {
        enabled: false
      },
      states: {
        hover: {
          enabled: false
        }
      }
    }
  ]

  return series
}

const preFormatDataFromResponse = (...response) => {
  let newData = []
  let query = {}
  let geo = {}
  let jIndex = 0

  const getPreFormattedOBJ = responseOBJ => {
    responseOBJ.data.forEach(item => {
      let aux = {
        geoset: `${jIndex}`,
        time: item.time,
        value: item.value
      }
      geo[jIndex] = responseOBJ.query.geo[item.geoset]
      jIndex++
      newData.push(aux)
    })
  }

  for (let i = 0; i < response.length; i++) {
    const responseOBJ = response[i];
    if ( responseOBJ.error === undefined ) { // no error if there's no data
      getPreFormattedOBJ(responseOBJ);
    }
  }
  query.geo = geo

  return {
    data: newData,
    query
  }
}

const getMaxAndMinValue = series => {
  let max
  let min

  let values = series[0].data.map(item => item.value).filter(v => v !== null);
  max = values[0]
  min = values[0]

  // max = Math.max( values );
  // min = Math.min( values );
  values.forEach(value => {
    if (value > max) max = value
    if (value < min) min = value
  })

  return { max, min }
}

const mapChartAdapter = {
  formatMapSeries,
  preFormatDataFromResponse,
  getMaxAndMinValue
}
export default mapChartAdapter



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/MapChart/MapChartAdapter.js